import _ from 'lodash';
import { fromJS } from 'immutable';
import React from 'react';
import ReactHighcharts from 'react-highcharts';

const LineChart = React.createClass({

  getDefaultProps() {
    return {
      series: fromJS([])
    };
  },

  shouldComponentUpdate(nextProps) {
    return nextProps.categories !== this.props.categories || nextProps.series !== this.props.series;
  },

  getChartOptions() {

    const series = this.props.series.toJS();

    let tickInterval = 0.1;

    if (window.location.pathname.split('/')[3] === 'presidential-candidates') {
      series.pop();
      tickInterval = 0.01;
    }

    const config = {
      chart: {
        backgroundColor: 'transparent'
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'MONTHLY AVERAGE VIEW',
        align: 'left',
        useHTML: true
      },
      xAxis: {
        crosshair: {
          width: 2,
          color: '#717c8d',
          dashStyle: 'shortdot'
        },
        categories: this.props.categories.toJS()
      },
      yAxis: {
        title: {
          text: ''
        },
        tickInterval: tickInterval,
        plotLines: [{
          value: 0,
          width: 1,
          color: '#808080'
        }],
        labels: {
          formatter: function() {
             return (this.value * 100).toFixed(0) +"%";
          }
        },
      },
      tooltip: {
        useHTML: true,
        shared: true,
        zIndex: 5,
        crosshair: [ true ],
        backgroundColor: "rgba(255,255,255,1)",
        formatter: function () {
          const points = _.map(this.points, (point) => {
            return `<b style="color:${point.series.color};">${point.series.name}:</b> ${(point.y * 100).toFixed(2)}%<br />`
          }).join('');

          return `${this.x}<br/><br/> ${points}`;
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        borderWidth: 0
      },
      series: series
    };

    return config;
  },

  render() {
    if (this.props.series.size) {
      return (
        <ReactHighcharts config={this.getChartOptions()} />
      );
    } else {
      return <div></div>
    }
  }

});

export default LineChart;



/** WEBPACK FOOTER **
 ** ./src/components/charts/line.js
 **/